import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import axios from 'axios';
import Button from 'react-bootstrap/Button';
import Card from 'react-bootstrap/Card';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import Modal from 'react-bootstrap/Modal';
import './landing.css';

const AuthComponent = () => {
  const navigate = useNavigate();
  const [phoneNumber, setPhoneNumber] = useState('');
  const [otp, setOtp] = useState('');
  const [showLoginOTP, setShowLoginOTP] = useState(false);
  const [captchaAnswer, setCaptchaAnswer] = useState('');
  const [userAnswer, setUserAnswer] = useState('');
  const [captchaImage, setCaptchaImage] = useState('');

  const generateCaptcha = () => {
    let num1 = Math.floor(Math.random() * 10);
    let num2 = Math.floor(Math.random() * 10);
    const operator = ['+', '-', '*'][Math.floor(Math.random() * 3)];

    // If the operator is subtraction, ensure num1 is greater than or equal to num2
    if (operator === '-' && num1 < num2) {
      const temp = num1;
      num1 = num2;
      num2 = temp;
    }

    const question = `What is ${num1} ${operator} ${num2}?`;

    // Safe calculation without using eval
    let answer;
    if (operator === '+') answer = num1 + num2;
    else if (operator === '-') answer = num1 - num2;
    else if (operator === '*') answer = num1 * num2;

    setCaptchaAnswer(answer.toString());

    const canvas = document.createElement('canvas');
    canvas.width = 200;
    canvas.height = 50;
    const ctx = canvas.getContext('2d');
    ctx.font = '20px Arial';
    ctx.fillText(question, 10, 30);
    const dataURL = canvas.toDataURL();
    setCaptchaImage(dataURL);
  };

  const handleOTPClose = () => setShowLoginOTP(false);

  const handleLoginSubmit = async (e) => {
    e.preventDefault();
    if(otp.length === 0){
      toast.error("Press Login button")
      return
    }
    try {
      const response = await axios.post('/api/verify', {
        phone: phoneNumber,
        otp: otp,
      });

      if(response.data.message === "Match" ){
        navigate("/downloadAdmit");
      }else{
        toast.error("Incorrect OTP");
      }
    } catch (error) {
      console.error('Error:', error);
    }
  };

  const handleGenerateOTP = async (e) => {
    e.preventDefault();
    if(userAnswer !== captchaAnswer){
      toast.error("Incorrect captcha")
      return
    }

    if(phoneNumber.length !== 10){
      toast.error("Please enter phone number")
      return
    }

    try {
      await axios.post('/api/sendOTP', {
        phone: phoneNumber,
      });

      setShowLoginOTP(true);
    } catch (error) {
      console.error('Error:', error);
    }
  };

  const resendOTP = async () =>{
    try {
      await axios.post('/api/sendOTP', {
        phone: phoneNumber,
      });
    } catch (error) {
      console.error('Error:', error);
    }
  };

  useEffect(() => {
    generateCaptcha();
  }, []);

  return (
    <div className="login-page">
      <header className="login-header">
        <img src="/logo_0.png" alt="Ladakh Police" />
      </header>

      <Navbar collapseOnSelect expand="lg" variant="dark" className="login-navbar">
        <Container>
          <Navbar.Brand href="/">Ladakh Police Constable Recruitment 2026</Navbar.Brand>
          <Navbar.Toggle aria-controls="responsive-navbar-nav" />
          <Navbar.Collapse id="responsive-navbar-nav">
            <Nav className="ms-auto">
              <Nav.Link href="/">Login</Nav.Link>
              <Nav.Link href="https://police.ladakh.gov.in/pages/pdf/contables_recruitment.pdf" target="_blank" rel="noopener noreferrer">
                Advertisement
              </Nav.Link>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>

      <main className="login-main">
        <Card className="login-card shadow-sm">
          <Card.Body>
            <h1 className="login-title">Login</h1>
            <p className="login-description">Enter your mobile number to receive a one-time password.</p>
            <form onSubmit={handleGenerateOTP}>
              <div className="mb-4">
                <label htmlFor="phoneNumber" className="form-label">Mobile number</label>
                <input
                  type="tel"
                  inputMode="numeric"
                  autoComplete="tel-national"
                  className="form-control"
                  pattern="[0-9]{10}"
                  maxLength={10}
                  id="phoneNumber"
                  placeholder="Enter 10-digit mobile number"
                  value={phoneNumber}
                  onChange={(e) => setPhoneNumber(e.target.value)}
                  required
                />
              </div>
              <div className="mb-4">
                <label htmlFor="captchaAnswer" className="form-label">CAPTCHA answer</label>
                <div className="login-captcha">
                  {captchaImage && <img src={captchaImage} alt="CAPTCHA arithmetic question" />}
                </div>
                <input
                  id="captchaAnswer"
                  className="form-control"
                  type="text"
                  inputMode="numeric"
                  autoComplete="off"
                  value={userAnswer}
                  placeholder="Enter the answer shown above"
                  onChange={(e) => setUserAnswer(e.target.value)}
                  required
                />
              </div>
              <Button type="submit" className="login-primary w-100">Login</Button>
            </form>
          </Card.Body>
        </Card>
      </main>

      <Modal show={showLoginOTP} onHide={handleOTPClose} centered className="login-otp-modal" aria-labelledby="login-otp-title">
        <Modal.Header closeButton>
          <Modal.Title id="login-otp-title">Enter OTP</Modal.Title>
        </Modal.Header>
        <form onSubmit={handleLoginSubmit}>
          <Modal.Body>
            <p>Enter the OTP sent to <strong>{phoneNumber}</strong>.</p>
            <div className="mb-3">
              <label htmlFor="otp" className="form-label">OTP</label>
              <input
                type="text"
                inputMode="numeric"
                autoComplete="one-time-code"
                className="form-control"
                id="otp"
                value={otp}
                onChange={(e) => setOtp(e.target.value)}
                required
              />
            </div>
            <Button type="button" variant="outline-primary" className="login-resend" onClick={resendOTP}>
              Resend OTP
            </Button>
          </Modal.Body>
          <Modal.Footer>
            <Button type="button" variant="secondary" onClick={handleOTPClose}>Close</Button>
            <Button type="submit" className="login-primary">Submit</Button>
          </Modal.Footer>
        </form>
      </Modal>
      <ToastContainer
        position="bottom-center"
        autoClose={false}
        hideProgressBar={true}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
    </div>
  );
};

export default AuthComponent;
